module.exports = __webpack_public_path__ + "static/media/app-logo.3ad8af15.png";